export default __webpack_public_path__ + "static/media/maze-3.7fd2872b.svg";